import React, { useEffect, useContext, useState, useRef } from 'react'
import { Tooltip } from 'react-tooltip'
import { Link } from "react-router-dom";
import { AutoSizer, List, Grid } from 'react-virtualized';
import Switch from "react-switch";

import { DefaultContext } from '../../context/context_default';
import { useDeckBuild } from './hooks';
import Filtro from '../../componentes/filter';
import { Card } from '../listaCards/componentes/card';
import ItemListDeckBuild from './componente/itemList';

import imgBG from "../../assets/imagens/bg_decklist.jpg";

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import StyleRoundedIcon from '@mui/icons-material/StyleRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import GraficoBarras from './componente/grafico_barras';
import CardsCuston from './componente/cards';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';

import DeckStats from '../deckPreview/componente/DeckStats';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const DeckBuild = ({ editar }) => {
	const {
		globalFirestoreData,
		getSubTipos,
		subTipos,
		tipos,
		getTipos,
		getPalavrasChave,
		palavraChave,
		getFortunas,
		getCausas,
		causas,
		fortunas,
		getRaridade,
		raridades,
		listCards,
		getListCards,
		is_descktop,
		filterFetch,
		setShowListCards,
		showListCards,
		showCardFlutuante,
		setShowCardFlutuante,
		validar_deckId_vs_userId,
		deck_tu_edit,
		deckName,
		setDeckName,
		conta_cartas_lsit,
		share_deck, setShare_deck,
		show_list_cards_deck

	} = useContext(DefaultContext);

	const {
		list,
		isOpenFilter,
		setIsOpenFilter,
		isOpenDeck,
		setIsOpenDeck,
		isOpenStatsModal,
		toggleStatsModal,
		toggleDrawerFilter,
		toggleDrawerDeck,
		zoom,
		toggleZoom,
		filtroDreck,
		setZoom,
		listCardDeck,
		setListCardDeck,
		listCardDeckMatriz,
		setListCardDeckMatriz,
		addCardToDeck,
		lessCardToDeck,

		editName,
		setEditName,
		colapseFortuna,
		setColapseFortuna,
		addCardToDeckMatriz,
		lessCardToDeckMatriz,
		salveDeck,
		setQuebradorDeck,
		quebradorDeck,
		load,
		search,
		searchChange,
		editMode,
		setEditMode,
		updateDeck

	} = useDeckBuild();


	const [column_count, setColumn_count] = useState(3)
	const [flag_att_coluna, setFlag_att_coluna] = useState(3)
	const [forceGridUpdate, setForceGridUpdate] = useState(false); // Estado para forçar a atualização
	const inputReference = useRef(null);

	const handleChange = (checked) => {
		setShare_deck(checked)
	}
	const delay = async (ms) => {
		return new Promise((resolve) =>
			setTimeout(resolve, ms));
	};

	const calc_column = (larg) => {
		var colun = parseInt(larg / (zoom ? 245 : 145))
		colun = colun == 0 ? 1 : colun

		if (colun == 1 && column_count != 1) {
			setColumn_count(colun)
			setForceGridUpdate(prevState => !prevState);

		}
		setColumn_count(colun)
	}



	useEffect(() => {

		setForceGridUpdate(prevState => !prevState);


	}, [zoom, isOpenDeck, showListCards])

	useEffect(() => {
		if (editar) {
			setEditMode(true);
		}

	}, [])
	useEffect(() => {
		if (editar && validar_deckId_vs_userId()) {
			setListCardDeckMatriz(deck_tu_edit.matriz)
			setListCardDeck(deck_tu_edit.arvore)
			setQuebradorDeck({ id: deck_tu_edit.quebrador })
			setDeckName(deck_tu_edit.nome)

			setShare_deck(deck_tu_edit?.share != null ? deck_tu_edit.share : true)
		} else {
			if (editar) {
				setEditMode(false);
			}
		}
	}, [globalFirestoreData])

	const cellRenderer = ({ columnIndex, key, rowIndex, style }) => {
		const index = rowIndex * column_count + columnIndex;
		const card = showListCards[index];
		var count = listCardDeck.filter(item => item.id == card?.id)
		count = count.map(item => item.qtd)
		var sum = count.reduce((accumulator, value) => accumulator + value, 0);

		count = quebradorDeck?.id == card?.id


		sum += count = count ? 1 : 0

		count = listCardDeckMatriz.filter(item => item.id == card?.id)
		count = count.map(item => item.qtd)
		sum += count.reduce((accumulator, value) => accumulator + value, 0);

		return (
			<div key={key} style={style} className='flex justify-center items-center flex-1 '>
				{card ? <div className='relative group'>

					<div onClick={card ? () => { card.deckTipo == 0 ? addCardToDeck(card?.id) : addCardToDeckMatriz(card?.id) } : null}>
						<Card card={card} zoom={zoom} index={columnIndex + 1} columMax={column_count} />
					</div>

					<Link to={'/detail/' + card?.id} target="_blank" className={` absolute ${zoom ? "right-5 top-4" : "right-1 top-6"} w-8 h-8 flex justify-center items-center rounded-full cursor-pointer group-hover:visible invisible hover:bg-slate-500 bg-slate-600 `} data-tooltip-delay-show={3000} data-tooltip-id="inf" data-tooltip-content="Informação da carta" data-tooltip-place="right"><Tooltip id="inf" className='z-50' /><InfoOutlinedIcon></InfoOutlinedIcon></Link>
					<div className={` absolute ${zoom ? "right-5 top-40" : "right-1 top-32"}`}>
						<div onClick={card ? () => { card.deckTipo == 0 ? addCardToDeck(card?.id) : addCardToDeckMatriz(card?.id) } : null} className={`  ${zoom ? "right-5 top-40" : "right-1 top-32"} w-8 h-8 flex justify-center items-center rounded-full cursor-pointer group-hover:visible invisible hover:bg-slate-500 bg-slate-600 `} data-tooltip-delay-show={3000} data-tooltip-id="plus" data-tooltip-content="Adicionar carta" data-tooltip-place="right"><Tooltip id="plus" className='z-50' /><AddCircleOutlineOutlinedIcon></AddCircleOutlineOutlinedIcon></div>
						<div onClick={card ? () => { card.deckTipo == 0 ? lessCardToDeck(card?.id) : lessCardToDeckMatriz(card?.id) } : null} className={`  ${zoom ? "right-5 top-[198px]" : "right-1 top-[165px]"} mt-2 w-8 h-8 flex justify-center items-center rounded-full cursor-pointer group-hover:visible invisible hover:bg-slate-500 bg-slate-600 `} data-tooltip-delay-show={3000} data-tooltip-id="less" data-tooltip-content="Remove carta" data-tooltip-place="right"><Tooltip id="less" className='z-50' /><RemoveCircleOutlineOutlinedIcon></RemoveCircleOutlineOutlinedIcon></div>
					</div>


					{sum != 0 ? <div className='select-none absolute flex justify-center items-center right-1 rounded border border-gray-400 top-16 bg-slate-700 w-10 h-9'>{sum}x</div> : null}
				</div> : null}
			</div>
		);
	};

	const estiloCard = {
		top: showCardFlutuante ? `${window.innerHeight * 0.8 > showCardFlutuante?.y ? showCardFlutuante?.y : window.innerHeight * 0.8}px` : '0',

	};

	const estiloDoComponente = {
		WebkitFilter: 'drop-shadow(0px 0px 4px #0f0f0f)',
		filter: 'drop-shadow(0px 0px 4px #0f0f0f)',
	};

	useEffect(() => {
		if (editName) {
			inputReference.current.focus();
		}
	}, [editName])

	useEffect(() => {
		if (!isOpenDeck) {
			setShowCardFlutuante(false);
		}
	}, [isOpenDeck])

	const divider = () => { return (<div className='flex-1 border-b border-slate-600 h-0'></div>) }

	return (
		<div style={{ backgroundImage: `url(${imgBG})`, }} className='h-full w-full bg-cover bg-center flex justify-center md:justify-end items-cente overflow-hidden'>
			<div className={` bg-slate-700 bg-opacity-[94%] h-full w-full flex justify-center md:justify-end items-cente `}>
				{listCards == [] || listCards == null ? <div className="prose max-w-none mx-auto p-6 overflow-y-scroll h-full">
					<section id="cartas-em-effect" className="mb-8">
						<h2 className="text-2xl font-bold mb-4">As Cartas em Effect</h2>
						<p>
							<strong>EFFECT</strong> é jogado com dois decks simultâneos (um deck principal e um auxiliar). O primeiro é composto por cartas a serem usadas em jogadas, enquanto o segundo é formado unicamente por cartas de fortuna, os recursos necessários para que as jogadas aconteçam.
						</p>
						<p>
							No deck principal, é possível encontrar diversos tipos de cartas, cada uma com uma forma de utilização e finalidade em jogo. Já no deck secundário, as fortunas precisam estar em sinergia com as cartas do deck principal.
						</p>
					</section>

					<section id="anatomia-cartas" className="mb-8">
						<h2 className="text-2xl font-bold mb-4">Anatomia e Tipos de Cartas</h2>
						<ol className="list-decimal ml-6">
							<li><strong>Nome:</strong> A identificação primária da carta.</li>
							<li><strong>Ícone da Causa:</strong> Determina a natureza ou origem da carta no universo de Effect.</li>
							<li><strong>Arte:</strong> Representa visualmente parte do universo de Effect.</li>
							<li><strong>Custo em Fortunas:</strong> Indica os tipos e a quantidade de fortunas necessárias para jogar a carta.</li>
							<li><strong>Caixa de Texto:</strong> Contém informações sobre os efeitos e habilidades da carta, além de textos narrativos.</li>
							<li><strong>Atributos Numéricos:</strong> Representam estatísticas ou habilidades, acompanhados de valores numéricos.</li>
							<li><strong>Ícone da Coleção/Expansão:</strong> Identifica a coleção ou expansão à qual a carta pertence.</li>
							<li><strong>Tipo de Carta e Subtipo:</strong> Indica a categoria (constritos, artefatos, eventos, etc.) e detalhes adicionais.</li>
							<li><strong>Ícone de Raridade:</strong> Define a raridade da carta e o número máximo de cópias permitidas em um deck.</li>
							<li><strong>Créditos do Artista:</strong> Identifica o criador da arte da carta.</li>
							<li><strong>Número na Coleção:</strong> Organiza a carta numericamente dentro da coleção.</li>
						</ol>
						<p><strong>Nota:</strong> A raridade de uma carta define o número máximo de cópias permitidas:</p>
						<ul className="list-disc ml-6">
							<li><strong>Comum:</strong> Até 5 cópias.</li>
							<li><strong>Incomum:</strong> Até 4 cópias.</li>
							<li><strong>Rara:</strong> Até 3 cópias.</li>
							<li><strong>Lendária:</strong> Até 2 cópias.</li>
						</ul>
						<p>
							Algumas cartas possuem a palavra <strong>"singular"</strong> no subtipo, o que limita o jogador a ter apenas uma cópia no campo.
						</p>
					</section>

					<section id="tipos-cartas" className="mb-8">
						<h2 className="text-2xl font-bold mb-4">Tipos de Cartas</h2>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Conscritos</h3>
							<p>
								São as tropas que lutam ao lado do jogador. Permanecem em jogo até serem “quebradas” ou removidas sob alguma condição. Entram em jogo “exaustas” e, uma vez “preparadas”, podem atacar, bloquear ou usar habilidades.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Conscritos-Artefatos</h3>
							<p>
								Combinam características de conscritos e artefatos, podendo ser afetados por efeitos de ambos os tipos.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Fortunas</h3>
							<p>
								Utilizadas como recursos, fortunas têm seu próprio deck (Matriz) e descarte (Fluxo). Os triângulos na caixa de texto indicam sua validade nos “Quatro Caminhos”.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Artefatos</h3>
							<p>
								Objetos poderosos usados para equipar cartas, aplicar efeitos ou serem consumidos em troca de benefícios.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Eventos</h3>
							<p>
								Ações que auxiliam nas jogadas. Após resolvidas, são enviadas para o descarte (Oblívio).
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Impactos</h3>
							<p>
								Alteram ou adicionam novas regras ao jogo. Alguns são anexados a cartas específicas e saem de jogo com elas.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Maestrias</h3>
							<p>
								Fornecem habilidades permanentes ou ativadas. Podem ter níveis de poder que exigem custos adicionais para subir.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Realidades</h3>
							<p>
								Afetam profundamente o jogo. Dividem-se em micro e macro-realidades, sendo que as macros quebram todas as outras.
							</p>
						</div>
						<div className="mb-6">
							<h3 className="text-xl font-semibold">Quebradores de Realidades</h3>
							<p>
								Representam o jogador no jogo. Não possuem custo em fortunas, mas são removidos do jogo se seus pontos de energia zerarem.
							</p>
						</div>
						<div>
							<h3 className="text-xl font-semibold">Mercenários</h3>
							<p>
								Versões mais fracas dos quebradores, com custos em fortunas. Podem substituir quebradores derrotados, mas têm limitações.
							</p>
						</div>
					</section>
				</div> :
					globalFirestoreData.userId && editMode != false ?
						<div className={`${isOpenFilter || isOpenDeck ? 'md:mr-[320px] duration-200' : 'mr-0 duration-200'} relative w-full h-full pt-20 transition-all p-2  `}>


							{showCardFlutuante?.card ? <div className={`${showCardFlutuante && is_descktop ? "" : "hidden"} w-40 h-auto   right-0 mr-2 absolute z-40`} style={estiloCard}>
								{/* <img className=' w-full h-full object-contain' style={estiloDoComponente} src={showCardFlutuante?.url_img} loading="lazy" ></img> */}
								<div className={`bg-slate-800 text-white shadow-md border-l-4 border-blue-500`}>
									<div className='p-2 pb-0'>{showCardFlutuante.card?.nome}</div>
									<div className='p-2 pt-0 text-xs'>{showCardFlutuante.card?.tipo?.map(e => tipos?.find(t => t.id == e)?.tipo + ' ')} / {showCardFlutuante.card?.sub_tipo?.map(e => subTipos?.find(t => t.id == e)?.tipo + ' ')}</div>

									{showCardFlutuante.card.custo || showCardFlutuante.card.poder || showCardFlutuante.card.vida ? <div className='border-b border-slate-700 '></div> : null}
									{showCardFlutuante.cardcusto ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Custo:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante.card.custo}</div>  </div> : null}
									{showCardFlutuante.card.p_a ? <div className='p-2 pb-0 pt-0 flex justify-between items-center text-xs'><div>Poder:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante.card.p_a}</div> </div> : null}
									{showCardFlutuante.card.vida ? <div className='p-2 pb-1 pt-1 flex justify-between items-center text-xs'><div>Vida:</div><div className='border-b border-slate-500 border-opacity-25 w-full mx-3'></div><div>{showCardFlutuante.card.vida}</div> </div> : null}


									{showCardFlutuante.card.p_c.length > 0 ? <div className='border-b border-slate-700 '></div> : null}
									{showCardFlutuante.card.p_c.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'>Palavras chave</div> : null}
									{palavraChave && showCardFlutuante.card ? showCardFlutuante.card?.p_c?.map(id => { return <div className='p-2 pb-0 pt-0 text-xs flex justify-start items-center'><div className='rounded-full w-1 h-1 bg-slate-300 mr-2 ml-2 '></div><div>{palavraChave?.find(item => item.id == id)?.nome} </div></div> }) : null}
									{showCardFlutuante.card.p_c.length > 0 ? <div className='p-2 pb-1 pt-1 text-xs'></div> : null}
								</div>
							</div> : null}

							<div className='flex space-x-2 mb-2 items-end'>

								<div className='flex-1 flex lg:space-x-2 lg:flex-row flex-col  lg:items-center justify-center '>

									<div className='flex flex-col'>
										<h2 className='min-w-fit text-2xl font-bold truncate'>Criador de Deck</h2>
										<p className='text-xs text-slate-300'>Cards encontrados: {showListCards?.length}</p>
									</div>
									<div class="relative w-full">
										<div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
											<SearchRoundedIcon></SearchRoundedIcon>
										</div>
										<input type="text" id="simple-search" onChange={searchChange} class="border   text-sm rounded-lg block w-full ps-10 p-2.5  bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" placeholder="Procure pelo nome de alguma carta..." required />
									</div>

								</div>
								<div className='p-4 bg-slate-500 hover:bg-slate-400 text-right w-10 h-10 flex justify-center items-center cursor-pointer rounded' onClick={toggleZoom} data-tooltip-delay-show={500} data-tooltip-id="Zoom" data-tooltip-content="Zoom" data-tooltip-place="bottom"><Tooltip id="Zoom" className='z-50' />{zoom ? <ZoomOutIcon></ZoomOutIcon> : <ZoomInIcon></ZoomInIcon>}</div>
								<div className='p-4 bg-slate-500 hover:bg-slate-400 text-right w-10 h-10 flex justify-center items-center cursor-pointer rounded' onClick={toggleDrawerFilter} data-tooltip-delay-show={500} data-tooltip-id="filter" data-tooltip-content="Filtro" data-tooltip-place="bottom"><Tooltip id="filter" className='z-50' /><FilterAltRoundedIcon></FilterAltRoundedIcon></div>
								<div className='p-4 bg-slate-500 hover:bg-slate-400 text-right w-10 h-10 flex justify-center items-center cursor-pointer rounded' onClick={toggleDrawerDeck} data-tooltip-delay-show={500} data-tooltip-id="deck" data-tooltip-content="Deck" data-tooltip-place="bottom"><Tooltip id="deck" className='z-50' /><StyleRoundedIcon className='rotate-180'></StyleRoundedIcon></div>
								<div className='p-4 bg-slate-500 hover:bg-slate-400 text-right w-10 h-10 flex justify-center items-center cursor-pointer rounded' onClick={filtroDreck} data-tooltip-delay-show={500} data-tooltip-id="visualiza" data-tooltip-content="Visualize cartas do deck" data-tooltip-place="bottom"><Tooltip id="visualiza" className='z-50' />{show_list_cards_deck ? <VisibilityOutlinedIcon></VisibilityOutlinedIcon> : <VisibilityOffOutlinedIcon></VisibilityOffOutlinedIcon>}</div>

							</div>

							<div className={` w-full h-[99%]  pb-[40px]   `}>

								<AutoSizer>
									{({ height, width }) => {

										calc_column(width)

										return (
											<Grid
												className={`justify-center  scrollbar-thin scrollbar-thumb-slate-600  scrollbar-rounded-sm  `}
												key={forceGridUpdate}
												cellRenderer={cellRenderer}
												columnCount={column_count}
												columnWidth={(column_count == 1 ? width : column_count == 2 ? width / 2.2 : (zoom ? 245 : 145))} // Largura de cada coluna
												height={height}
												rowCount={Math.ceil(showListCards.length / column_count)}
												rowHeight={(zoom ? 345 : 205)} // Altura de cada linha
												width={width} // Largura total do grid
											/>
										)
									}}
								</AutoSizer>
								{/* {listCards.map(item => { return <Card card={item} zoom={zoom} /> })} */}
							</div>


							<aside className={`${isOpenDeck ? 'translate-x-0 duration-200' : ' duration-300 translate-x-full '} overflow-x-visible bg-slate-700  pt-16 transition-transform  fixed top-0 right-0 z-30 w-80 h-screen shadow-lg flex flex-col p-3 border-l border-slate-600 border-opacity-60`}>


								<div className='flex flex-col justify-start overflow-y-auto  scrollbar-thin overflow-x-hidden scrollbar-thumb-slate-600  scrollbar-rounded-sm pr-2 h-full pt-4'>
									<div className='flex justify-between w-full mb-1'>
										<div className='flex items-center '  >
											<EditRoundedIcon className=' cursor-pointer' onClick={() => { setEditName(true); }} />
											{editName ?
												<div className='relative ml-3'>
													<input className='text-gray-900 rounded bg-slate-400 p-1 mt-1 w-48' ref={inputReference} value={deckName} onChange={(e) => { setDeckName(e.target.value) }} ></input>
													<div class=" absolute end-1 top-1/4 w-7 rounded-full  hover:bg-slate-500 scale-75 text-slate-900" onClick={() => { setEditName(false) }}><CheckRoundedIcon /></div>
												</div> :
												<span onClick={() => { setEditName(true); }} className='cursor-pointer pl-3'>{deckName}</span>
											}


										</div>

										<div className='rounded-full w-7 h-7 flex justify-center items-center bg-slate-600 hover:bg-opacity-75 cursor-pointer' onClick={toggleDrawerDeck}><CloseRoundedIcon></CloseRoundedIcon>
										</div>

									</div>
									<label className='flex justify-between items-center mt-2'>
										<span>Tornar deck público.</span>
										<Switch onChange={handleChange} checked={share_deck}
											onColor="#ff9336"
											onHandleColor="#f97316"
											handleDiameter={20}
											uncheckedIcon={false}
											checkedIcon={false}
											boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
											activeBoxShadow="0px 0px 1px 5px rgba(0, 0, 0, 0.2)"
											height={10}
											width={35} />
									</label>
									{listCardDeck && listCardDeckMatriz ?

										<div className='flex items-center justify-around space-x-3 my-4 rounded-lg border border-slate-600 border-opacity-50 bg-gradient-to-r from-slate-800 to-slate-700 bg-opacity-70 p-4 shadow-lg'>
											<div className='text-2xl text-slate-200 flex flex-col items-center'>
												<div className='text-xs font-medium text-slate-400 mb-1'>Árvore</div>
												<div className='font-bold text-blue-400'>
													{conta_cartas_lsit(listCardDeck)}/
													{conta_cartas_lsit(listCardDeck) > 40 ? '50' : conta_cartas_lsit(listCardDeck) > 30 ? '40' : '30'}
												</div>
											</div>
											<div className='w-px h-8 bg-slate-600'></div>
											<div className='text-2xl text-slate-200 flex flex-col items-center'>
												<div className='text-xs font-medium text-slate-400 mb-1'>Matriz</div>
												<div className='font-bold text-purple-400'>
													{conta_cartas_lsit(listCardDeckMatriz)}/
													{conta_cartas_lsit(listCardDeckMatriz) > 40 ? '50' : conta_cartas_lsit(listCardDeckMatriz) > 30 ? '40' : '30'}
												</div>
											</div>

										</div>

										// <div className='flex items-center justify-around space-x-3 my-2 mt-4 rounded-md border border-slate-800 bg-slate-800 bg-opacity-50 p-1'>

										// 	<div className='text-2xl text-slate-300 flex flex-col items-center'><div className='text-sm'>Arvore</div><div>
										// 		{conta_cartas_lsit(listCardDeck)}/
										// 		{conta_cartas_lsit(listCardDeck) > 40 ? '50' : conta_cartas_lsit(listCardDeck) > 30 ? '40' : '30'}
										// 	</div></div>
										// 	<div className='text-2xl text-slate-300 flex flex-col items-center'><div className='text-sm'>Matriz</div><div>
										// 		{conta_cartas_lsit(listCardDeckMatriz)}/
										// 		{conta_cartas_lsit(listCardDeckMatriz) > 40 ? '50' : conta_cartas_lsit(listCardDeckMatriz) > 30 ? '40' : '30'}
										// 	</div></div>

										// </div> 
										: null
									}

									{/* Botão de Estatísticas */}
									<div className='mt-4'>
										<button
											onClick={() => toggleStatsModal(true)}
											className='w-full flex items-center justify-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md transition-colors duration-200'
										>
											<BarChartIcon className='text-lg' />
											<span>Estatísticas do Deck</span>
										</button>
									</div>

									<div className='flex items-center space-x-3 my-4 mt-6'>
										<span className='text-xs font-semibold text-slate-300 bg-slate-600 bg-opacity-50 px-2 py-1 rounded'>QUEBRADOR</span>
										{divider()}
									</div>

									<div>
										{quebradorDeck ? <ItemListDeckBuild item={quebradorDeck} lessItem={() => { }} addItem={() => { }} className='overflow-x-visible' > </ItemListDeckBuild> : null}
									</div>



									<div className='flex items-center space-x-3 my-4 mt-6'>
										<span className='text-xs font-semibold text-slate-300 bg-blue-600 bg-opacity-30 px-2 py-1 rounded'>ÁRVORE</span>
										{divider()}
									</div>
									<GraficoBarras listCardDeck={listCardDeck}></GraficoBarras>

									<div className="flex flex-col justify-center items-center w-full mt-5">
										<div className="border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm p-1">
											<div className="h-auto">
												{listCardDeck.map((item, index) => (
													<ItemListDeckBuild
														key={index}
														item={item}
														lessItem={lessCardToDeck}
														addItem={addCardToDeck}
														className="overflow-x-visible"
													/>
												))}
											</div>
										</div>
									</div>

									<div className='flex items-center space-x-3 my-4 mt-6'>
										<span className='text-xs font-semibold text-slate-300 bg-purple-600 bg-opacity-30 px-2 py-1 rounded'>MATRIZ</span>
										{divider()}
									</div>

									{/* <GraficoBarras></GraficoBarras> */}

									<div className="flex flex-col justify-center items-center w-full mt-5">
										<div className="border border-dashed border-gray-500 rounded-md w-full min-h-[200px] max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600 scrollbar-rounded-sm p-1">
											<div className="h-auto">
												{listCardDeckMatriz.map((item, index) => (
													<ItemListDeckBuild
														key={index}
														item={item}
														lessItem={lessCardToDeckMatriz}
														addItem={addCardToDeckMatriz}
														className="overflow-x-visible"
													/>
												))}
											</div>
										</div>
									</div>

									<div className='flex justify-end mt-4 select-none mb-6'>
										<div className={`${load ? "bg-orange-300" : "bg-orange-500"} hover:bg-orange-400 cursor-pointer  rounded-md px-4 py-2`} onClick={() => { editMode ? updateDeck() : salveDeck() }} disable={load} >{editMode ? 'Salvar Edição' : 'Salvar'}</div>
									</div>









								</div>
							</aside>
							<aside className={`${isOpenFilter ? 'translate-x-0 duration-200' : ' duration-300 translate-x-full '}  bg-slate-700  pt-20 transition-transform  fixed top-0 right-0 z-30 w-80 h-screen shadow-lg flex flex-col p-3 border-l border-slate-600 border-opacity-60 `}>


								<Filtro toggleDrawer={toggleDrawerFilter} search={search} />
							</aside>
						</div>
						:
						editMode == false ? <div className='mt-16 w-full h-full flex flex-col justify-center items-center'>
							<div>Não pode Editar um deck que não é seu. em caso de erro de reload na pagina</div>
							<div>Em caso de erro de reload na pagina</div>
							<div>Ou volte para a lista de decks</div>
						</div> :
							<div className='mt-16 w-full h-full flex justify-center items-center'><div>Precisa logar</div></div>
				}


			</div>

			{/* Modal de Estatísticas */}
			{isOpenStatsModal && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
					<div className="bg-slate-900 rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
						<div className="sticky z-10 top-0 bg-slate-900 border-b border-slate-700 p-4 flex justify-between items-center">
							<h2 className="text-xl font-semibold text-slate-200">Estatísticas do Deck</h2>
							<button
								onClick={() => toggleStatsModal(false)}
								className="text-slate-400 hover:text-slate-200 transition-colors"
							>
								<CloseRoundedIcon />
							</button>
						</div>
						<div className="p-4">
							<DeckStats
								deck={{
									nome: deckName,
									user_id: globalFirestoreData?.userId
								}}
								arvore={listCardDeck || []}
								matriz={listCardDeckMatriz || []}
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default DeckBuild